var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-button',{staticClass:"btn btn-info ml-4 text-uppercase",on:{"click":function($event){return _vm.paidQuotation()}}},[_vm._v("\n  Marcar como pago "),_c('i',{staticClass:"fas fa-dollar-sign"})])
}
var staticRenderFns = []

export { render, staticRenderFns }